import { render, staticRenderFns } from "./subject-property-page.vue?vue&type=template&id=d1a2c76a&scoped=true"
import script from "./subject-property-page.vue?vue&type=script&lang=ts"
export * from "./subject-property-page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a2c76a",
  null
  
)

export default component.exports